import Link from 'next/link';
import i18n from 'src/utils/translate';
import NavBar from 'src/components/navBar';

export default function TagNavbar({ tagName, resultsType }: { tagName: string, resultsType: string }) {
  return (
    <NavBar>
      <Link
        as={`/tag/${tagName}`}
        className={resultsType === 'posts' ? 'active' : ''}
        href={`/tag?slug=${tagName}&type=posts`}
      >
        {i18n.t('Posts')}
      </Link>
      <Link
        as={`/tag/${tagName}?type=communities`}
        className={resultsType === 'communities' ? 'active' : ''}
        href={`/tag?slug=${tagName}&type=communities`}
      >
        {i18n.t('Communities')}
      </Link>
    </NavBar>
  );
}
